
function areQuestionsRecommended(caseConf) {
  return caseConf.dialogue && caseConf.dialogue.questions && caseConf.dialogue.questions.length;
}

function areCommandsRecommended(caseConf) {
  return caseConf.dialogue && caseConf.dialogue.commands && caseConf.dialogue.commands.length;
}

function areUnsolicitedRecommended(caseConf) {
  return caseConf.dialogue && caseConf.dialogue.unsolicited && caseConf.dialogue.unsolicited.length
}

function areCallsRecommended(caseConf) {
  return caseConf.dialogue && caseConf.dialogue.calls && caseConf.dialogue.calls.length;
}

function isAiEnabled(caseConf) {
  return caseConf.dialogue && caseConf.dialogue.aiEnabled;
}

function isAiDisabled(caseConf) {
  return !isAiEnabled(caseConf)
}

function areAiQuestionsRecommended(caseConf) {
  return caseConf.dialogue && caseConf.dialogue.aiEnabled && caseConf.dialogue.aiQuestions && caseConf.dialogue.aiQuestions.length;
}

function areAiUnsolicitedRecommended(caseConf) {
  return caseConf.dialogue && caseConf.dialogue.aiEnabled && caseConf.dialogue.aiUnsolicited && caseConf.dialogue.aiUnsolicited.length;
}

function areAiEffectsRecommended(caseConf) {
  return caseConf.dialogue && caseConf.dialogue.aiEnabled;
}

module.exports = {
  areQuestionsRecommended,
  areCommandsRecommended,
  areUnsolicitedRecommended,
  areCallsRecommended,
  isAiEnabled,
  isAiDisabled,
  areAiQuestionsRecommended,
  areAiUnsolicitedRecommended,
  areAiEffectsRecommended
}